import { Anchor, Box, Grommet, Heading, Layer, Text } from 'grommet'
import React, { Component } from 'react'
import { Switch, Route, useLocation, useParams } from 'react-router-dom'
import { DonationReportPage } from './components/Donations'
import { ErrorCard, SupportIconCard } from './components/Cards'
import { MotionLayer } from './components/Motion'
import Toasts from './components/Toasts'
import { AppContext } from './libs/context'
import { setStateForErrorResponse, setStateForNewToast, setStateToRemoveToast } from './libs/notify'
import { meshTheme } from './libs/theme'
import { LogoWithNoTagLine } from './Image'
import { networkMap, tokenInsert } from './libs/common'
import { NetworkMap } from './components/NetworkV2'
import {
  FormNextLink,
  Mail, Phone
} from 'grommet-icons'
import { StorePosterPage } from './components/StorePosters'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const PublicHeader = ({ children, authUser }) => (
  <Box
    border={{ side: 'bottom', color: 'light-3' }}
    direction="row"
    background="white"
    height={'60px'}
    align={'center'}
  >
    <Box direction="row" flex="grow" pad="small" gap="xxsmall" align={'center'}>
      <Box pad={{ bottom: '6px' }} height={'32px'} width={'150px'}>
        <LogoWithNoTagLine />
      </Box>
      {/*<Heading level={3} margin={'none'}>*/}
      {/*  Reports*/}
      {/*</Heading>*/}
    </Box>
    <Box flex={'grow'} pad="small" align={'end'}>
      {children}
    </Box>
    {/*<Box*/}
    {/*  fill="vertical"*/}
    {/*  pad={{ horizontal: 'xsmall' }}*/}
    {/*  width={{ min: 'xsmall' }}*/}
    {/*  background={'dark-1'}*/}
    {/*>*/}
    {/*  <AuthUserMenu*/}
    {/*    fill*/}
    {/*    justifyContent={'between'}*/}
    {/*    focusIndicator={false}*/}
    {/*    dropProps={{*/}
    {/*      margin: { top: 'xsmall' }*/}
    {/*    }}*/}
    {/*    authUser={authUser}*/}
    {/*  />*/}
    {/*</Box>*/}
  </Box>
)
const NetworkMapHeaderV2 = ({ children, authUser, region }) => (
  <Layer position='top' plain modal={false}>
    <Box
      background={'#484487'}
      pad={'small'}
      justify="center"
      round={{ corner: 'bottom' }}
      align="center"
      flex={false}
      elevation='large'
      direction={'row'}

    >
      <Anchor
        size={'large'}
        href={'https://foodmesh.ca/join-the-network/'}
        color={'#fff'}
        target={'_blank'}
        label={(<Box justify='center' align='center'
          direction='row'><Heading margin={'xsmall'} level={3}>Join our Food Recovery Network</Heading></Box>)}
      />
      <FormNextLink color={'#fff'} />
    </Box>
    <Layer plain={true} modal={false} position='top-right'>
      <Box round={{ corner: 'bottom-left' }} direction='row' align='center' pad={'small'} background={'#484487'}>
        <Anchor
          size={'medium'}
          href={'https://foodmesh.ca/contact/'}
          target={'_blank'}
          // reverse
          color={'#fff'}
          label={<Heading margin={'xsmall'} level={3}>Contact Us</Heading>}
        />
      </Box>
    </Layer>
  </Layer>
)
const NetworkMapHeader = ({ children, authUser, region }) => (
  <Box
    border={{ side: 'bottom', color: 'light-6', size: 'xsmall' }}
    direction="row"
    background="dark-3"
    height={'70px'}
    align={'between'}
  >
    <Box direction="row" flex="grow" pad={{ left: 'medium' }} gap="xxsmall" align={'center'}>
      <Heading level={2} margin={'none'} color={'white'}>
        {region} Food Recovery Network
      </Heading>
    </Box>
    <Box
      pad={{ right: 'medium' }}
      justify="center"
      align="center"
      flex={false}
      direction={'row'}
      fill={'vertical'}
    >
      <Anchor
        size={'small'}
        href={'https://foodmesh.ca/join-the-network/'}
        color={'white'}
        target={'_blank'}
        label={`Join the ${region} network`}
      />
      <FormNextLink color={'dark-6'} />
    </Box>
    <Box
      background="white"
      direction="row"
      fill={'vertical'}
      pad={{ left: 'medium' }}
      gap="xxsmall"
      align={'center'}
      justify={'center'}
      flex={false}
    >
      <Anchor
        size={'small'}
        href={'https://foodmesh.ca/contact/'}
        target={'_blank'}
        // reverse

        label={'Contact us'}
      />
      <FormNextLink color={'light-6'} />
      {/*<RoundIconButton Icon={Mail} color={'mesh-green-2'} />*/}

      <Box pad={{ bottom: '6px' }} height={'32px'} width={'150px'}>
        <LogoWithNoTagLine />
      </Box>
    </Box>
  </Box>
)

export class PublicApp extends Component {
  showResponseAsError = setStateForErrorResponse.bind(this)
  showAsToast = setStateForNewToast.bind(this)
  removeToast = setStateToRemoveToast.bind(this)
  state = {
    toasts: [],
    error: null,
    apiLoading: false,
    help: false
  }
  render() {
    const { path, url } = this.props.match //useRouteMatch()
    const { pathname } = this.props.location //useRouteMatch()
    const appContextValue = {
      actions: {
        showResponseAsError: this.showResponseAsError,
        showAsToast: this.showAsToast
      }
    }
    console.log(pathname)
    const { error, help, toasts, apiLoading } = this.state
    const fvrdPath = `${path}/network/fvrd/e8d28d51a4e5f5ed533ece45448eacc3`
    const rdnoPath = `${path}/network/rdno/aebzweyn7xkbymwfjkm83v5kyj3gpjkz`
    const covPath = `${path}/network/cov/0pi5141oymvonagoftcgvazmoiu4zc60`
    return (
      <Grommet theme={meshTheme} full>
        <AppContext.Provider value={appContextValue}>
          <Box fill>
            {pathname.startsWith(`${path}/network/`) ?
              <NetworkMapHeaderV2 region={pathname.indexOf(fvrdPath) > -1 ? 'FVRD' : 'RDNO'} /> : <PublicHeader />}
            <Box direction={'row'} fill background="light-1" overflow={'hidden'}>
              <Switch>
                <Route
                  path={`${path}/charity/:receiverId/reports`}
                  render={(props) => <PublicDonationReport {...props} />}
                />
                <Route
                  path={`${path}/store/:storeId/reports`}
                  render={(props) => <PublicDonationReport {...props} />}
                />
                <Route
                  path={`${path}/store/:storeId/posters`}
                  render={(props) => <PublicStorePoster {...props} />}
                />
                <Route path={rdnoPath} render={(props) => <NetworkMap values={networkMap.rdno}
                  {...props} />} />
                <Route path={fvrdPath} render={(props) => <NetworkMap values={networkMap.fvrd}
                  {...props} />} />
                <Route path={covPath} render={(props) => <NetworkMap values={networkMap.cov}
                  {...props} />} />
                <Route path={path}>
                  <h3>Ooops! Did you type in the wrong url?</h3>
                </Route>
              </Switch>
            </Box>
          </Box>

          {error && (
            <Layer
              background={'none'}
              onEsc={this.showResponseAsError}
              onClickOutside={this.showResponseAsError}
            >
              <ErrorCard closeAction={this.showResponseAsError} {...error} />
            </Layer>
          )}
          {help && (
            <Layer background={'none'}>
              <SupportIconCard
                heading={'Contact us'}
                closeAction={() => this.setState({ help: false })}
                SupportIcon={Mail}
                supportEmail={'hello@foodmesh.ca'}
                show={help}
              />
            </Layer>
          )}
          {toasts && toasts.length > 0 && (
            <MotionLayer background={'none'} modal={false} position={'bottom-left'}>
              <Toasts toasts={toasts} removeAction={this.removeToast} />
            </MotionLayer>
          )}
        </AppContext.Provider>
      </Grommet>
    )
  }
}

const PublicDonationReport = (props) => {
  let { receiverId, storeId } = useParams()
  let query = useQuery()
  let apiParams = {}
  if (receiverId !== undefined) {
    apiParams['_options'] = {
      customToken: tokenInsert(query.get('tk'), 'r_' + receiverId),
      tkType: 'readOnly'
    }
    apiParams['receiver_id'] = receiverId
  }
  if (storeId !== undefined) {
    apiParams['_options'] = {
      customToken: tokenInsert(query.get('tk'), 's_' + storeId),
      tkType: 'readOnly'
    }
    apiParams['from_store_id'] = storeId
  }

  return <DonationReportPage apiParams={apiParams} />
}
const PublicStorePoster = (props) => {
  let { storeId } = useParams()
  let query = useQuery()
  let apiParams = {}
  if (storeId !== undefined) {
    apiParams['_options'] = {
      customToken: tokenInsert(query.get('tk'), 's_' + storeId),
      tkType: 'readOnly'
    }
    apiParams['from_store_id'] = storeId
    apiParams['annotate_metrics'] = true
  }

  // return <StorePoster apiPath={'retail/reports/donation_totals'} apiParams={apiParams} />
  return <StorePosterPage apiPath={'retail/reports/donation_totals'} apiParams={apiParams} />
}
